export enum EVisitorType {
  /** New visitor */
  NEW = 'NEW',
  /** Returning visitor */
  RETURNING = 'RETURNING',
}

export interface IFilterVisitorType {
  value?: EVisitorType[];
}
